import { useSelector } from "react-redux";


const useBillPaymentUserId = () => {
    let id = "";
    const { data } = useSelector((s) => s.auth.userPersist);

    if (data.token){
        if (data.employer.userType === "employer-admin"){
            id = data?.employer?.mainEmployerId;
        }
        else{
            id = data?.employer?._id;
        }
    }

    
    return {
        billPaymentUserId: id,
    };
}


export default useBillPaymentUserId;
